import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

export function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.copyright}>© {currentYear} easyzilla</div>
        <div className={styles.links}>
          <Link to="privacypolicy" target="_blank">
            Privacy Policy
          </Link>
          <Link to="terms" target="_blank">
            Terms of Service
          </Link>
          <a href="mailto:hello@easyzilla.com">Contact Support</a>
        </div>
      </div>
    </footer>
  );
}
